<template>

  <el-menu
      default-active="1"
      class="el-menu-vertical-demo"
      :router="false"
      :collapse="collapsed"
      :collapse-transition="false"
  >

    <!-- ── ОБЗОР ─────────────────────────────────────────── -->
    <el-menu-item-group>
      <template #title>{{$t("Menu.SectionOverview")}}</template>

      <el-tooltip :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('report.view')" placement="right" popper-style="max-width:240px">
        <el-menu-item id="tour-dashboard" index="1" :class="{ 'menu-item-restricted': !can('report.view') }">
          <a class="menu-link-overlay" :href="resolveHref('/')" @click="onMenuAnchorClick($event, '/', 'report.view')"></a>
          <el-icon><DataBoard /></el-icon>
          <template #title>{{$t("Menu.Dashboard")}}</template>
        </el-menu-item>
      </el-tooltip>

      <el-tooltip :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('report.view')" placement="right" popper-style="max-width:240px">
        <el-menu-item id="tour-dashboards" index="15" :class="{ 'sidebar-premium-item': isFreeTariff, 'menu-item-restricted': !can('report.view') }" @mouseenter="openDashboardsDropdown($event)" @mouseleave="closeDashboardsDropdownWithDelay()">
          <a class="menu-link-overlay" :href="resolveHref('/dashboards')" @click="onMenuAnchorClick($event, '/dashboards', 'report.view')"></a>
          <i v-if="collapsed" class="fas fa-th-large"></i>
          <div v-else class="hover-resources" ref="dashboardsTrigger">
            <i class="fas fa-th-large"></i>
            <span class="menu-title">{{$t("Menu.Dashboards")}}</span>
            <i class="fas submenu-caret ms-auto" :class="dashboardsCaretIconClass" aria-hidden="true"></i>
          </div>
        </el-menu-item>
      </el-tooltip>

      <el-tooltip :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('communication.users.list')" placement="right" popper-style="max-width:240px">
        <el-menu-item id="tour-users" index="5" :class="{ 'sidebar-premium-item': isFreeTariff, 'menu-item-restricted': !can('communication.users.list') }">
          <a class="menu-link-overlay" :href="resolveHref('/users')" @click="onMenuAnchorClick($event, '/users', 'communication.users.list')"></a>
          <i class="fas fa-users"></i>
          <template #title>{{$t("Menu.Users")}}</template>
        </el-menu-item>
      </el-tooltip>

      <!-- Заявки на вступление бывают только у каналов и групп: у бота в личке такого нет -->
      <el-tooltip v-if="hasJoinRequests" :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('join_requests.view')" placement="right" popper-style="max-width:240px">
        <el-menu-item id="tour-join-requests" index="join-requests" :class="{ 'sidebar-premium-item': isFreeTariff, 'menu-item-restricted': !can('join_requests.view') }">
          <a class="menu-link-overlay" :href="resolveHref('/join-requests')" @click="onMenuAnchorClick($event, '/join-requests', 'join_requests.view')"></a>
          <i class="fas fa-user-check"></i>
          <template #title>{{$t("Menu.JoinRequests")}}</template>
        </el-menu-item>
      </el-tooltip>
    </el-menu-item-group>

    <div class="sidebar-section-sep" />

    <!-- ── ОТЧЕТЫ ─────────────────────────────────────────── -->
    <el-menu-item-group>
      <template #title>{{$t("Menu.SectionReports")}}</template>

      <el-tooltip :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('report.view')" placement="right" popper-style="max-width:240px">
        <el-menu-item id="tour-reports" index="14" :class="{ 'menu-item-restricted': !can('report.view') }" @mouseenter="openReportsDropdown($event)" @mouseleave="closeReportsDropdownWithDelay()">
          <a class="menu-link-overlay" :href="resolveHref('/user-reports')" @click="onMenuAnchorClick($event, '/user-reports', 'report.view')"></a>
          <el-icon v-if="collapsed"><Location /></el-icon>
          <div v-else class="hover-resources" ref="reportsTrigger">
            <el-icon><Location /></el-icon>
            <span class="menu-title">{{$t("Menu.Reports")}}</span>
            <i class="fas submenu-caret ms-auto" :class="reportsCaretIconClass" aria-hidden="true"></i>
          </div>
        </el-menu-item>
      </el-tooltip>

      <el-tooltip :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('cohorts.view')" placement="right" popper-style="max-width:240px">
        <el-menu-item id="tour-cohorts" index="cohorts" :class="{ 'sidebar-premium-item': isFreeTariff, 'menu-item-restricted': !can('cohorts.view') }">
          <a class="menu-link-overlay" :href="resolveHref('/cohorts')" @click="onMenuAnchorClick($event, '/cohorts', 'cohorts.view')"></a>
          <i class="fas fa-users"></i>
          <template #title>{{$t("Menu.Cohorts")}}</template>
        </el-menu-item>
      </el-tooltip>

      <el-tooltip :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('report.view')" placement="right" popper-style="max-width:240px">
        <el-menu-item id="tour-conversions" index="8" :class="{ 'sidebar-premium-item': isFreeTariff, 'menu-item-restricted': !can('report.view') }" @mouseenter="openConversionsDropdown($event)" @mouseleave="closeConversionsDropdownWithDelay()">
          <a class="menu-link-overlay" :href="resolveHref('/conversion')" @click="onMenuAnchorClick($event, '/conversion', 'report.view')"></a>
          <i v-if="collapsed" class="fas fa-percentage"></i>
          <div v-else class="hover-resources" ref="conversionsTrigger">
            <i class="fas fa-percentage"></i>
            <span class="menu-title">{{$t("Menu.Conversions")}}</span>
            <i class="fas submenu-caret ms-auto" :class="conversionsCaretIconClass" aria-hidden="true"></i>
          </div>
        </el-menu-item>
      </el-tooltip>

      <el-tooltip :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('report.view')" placement="right" popper-style="max-width:240px">
        <el-menu-item index="2" :class="{ 'menu-item-restricted': !can('report.view') }" @click="openReportsFixed($event)">
          <el-icon><Location /></el-icon>
          <template #title>
            <span>{{$t("Menu.Reports")}}</span>
            <el-tag type="info" effect="dark" size="small" class="ms-1" style="height:16px;line-height:16px;padding:0 4px;font-size:10px;border:none;flex-shrink:0;">old</el-tag>
          </template>
        </el-menu-item>
      </el-tooltip>
    </el-menu-item-group>

    <div class="sidebar-section-sep" />

    <!-- ── ИНСТРУМЕНТЫ ──────────────────────────────────── -->
    <el-menu-item-group>
      <template #title>{{$t("Menu.SectionTools")}}</template>

      <el-tooltip :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('tasker.task.view')" placement="right" popper-style="max-width:240px">
        <el-menu-item id="tour-broadcasting" index="10" :class="{ 'menu-item-restricted': !can('tasker.task.view') }">
          <a class="menu-link-overlay" :href="resolveHref('/broadcasting')" @click="onMenuAnchorClick($event, '/broadcasting', 'tasker.task.view')"></a>
          <i class="fa-solid fa-paper-plane"></i>
          <template #title>{{$t("Menu.Broadcasting")}}</template>
        </el-menu-item>
      </el-tooltip>

      <el-tooltip :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('settings.view')" placement="right" popper-style="max-width:240px">
        <el-menu-item id="tour-utm" index="4" :class="{ 'menu-item-restricted': !can('settings.view') }">
          <a class="menu-link-overlay" :href="resolveHref('/utm-builder')" @click="onMenuAnchorClick($event, '/utm-builder', 'settings.view')"></a>
          <i class="fas fa-tools"></i>
          <template #title>{{$t("Menu.UTMBuilder")}}</template>
        </el-menu-item>
      </el-tooltip>

      <el-tooltip :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('workflows.view')" placement="right" popper-style="max-width:240px">
        <el-menu-item id="tour-workflows" index="workflows" :class="{ 'menu-item-restricted': !can('workflows.view') }">
          <a class="menu-link-overlay" :href="resolveHref('/workflows')" @click="onMenuAnchorClick($event, '/workflows', 'workflows.view')"></a>
          <i class="fas fa-project-diagram"></i>
          <template #title>
            <span>{{$t("Menu.Workflows")}}</span>
          </template>
        </el-menu-item>
      </el-tooltip>

      <el-tooltip :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('integrations.view')" placement="right" popper-style="max-width:240px">
        <el-menu-item id="tour-integrations" index="integrations" :class="{ 'menu-item-restricted': !can('integrations.view') }">
          <a class="menu-link-overlay" :href="resolveHref('/integrations')" @click="onMenuAnchorClick($event, '/integrations', 'integrations.view')"></a>
          <i class="fas fa-plug"></i>
          <template #title>{{$t("Menu.Integrations")}}</template>
        </el-menu-item>
      </el-tooltip>

      <el-menu-item v-if="$store.state.init.user && $store.state.init.user.admin" id="tour-assistant" index="assistant">
        <a class="menu-link-overlay" :href="resolveHref('/assistant')" @click="onMenuAnchorClick($event, '/assistant')"></a>
        <i class="fas fa-robot"></i>
        <template #title>{{$t("Menu.Assistant")}}</template>
      </el-menu-item>

      <el-tooltip :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('report.view')" placement="right" popper-style="max-width:240px">
        <el-menu-item id="tour-referral" index="referral" :class="{ 'menu-item-restricted': !can('report.view') }" @mouseenter="openReferralDropdown($event)" @mouseleave="closeReferralDropdownWithDelay()">
          <a class="menu-link-overlay" :href="resolveHref('/referral')" @click="onMenuAnchorClick($event, '/referral', 'report.view')"></a>
          <i v-if="collapsed" class="fas fa-gift"></i>
          <div v-else class="hover-resources" ref="referralTrigger">
            <i class="fas fa-gift"></i>
            <span class="menu-title">{{$t("Menu.Referral")}}</span>
            <i class="fas submenu-caret ms-auto" :class="referralCaretIconClass" aria-hidden="true"></i>
          </div>
        </el-menu-item>
      </el-tooltip>

      <el-menu-item v-if="$store.state.init.user && $store.state.init.user.admin" id="tour-ads" index="ads" @mouseenter="openAdsDropdown($event)" @mouseleave="closeAdsDropdownWithDelay()">
        <a class="menu-link-overlay" :href="resolveHref('/ads/report')" @click="onMenuAnchorClick($event, '/ads/report')"></a>
        <i v-if="collapsed" class="fas fa-bullhorn"></i>
        <div v-else class="hover-resources" ref="adsTrigger">
          <i class="fas fa-bullhorn"></i>
          <span class="menu-title">{{$t("Menu.Ads")}}</span>
          <i class="fas submenu-caret ms-auto" :class="adsCaretIconClass" aria-hidden="true"></i>
        </div>
      </el-menu-item>
    </el-menu-item-group>

    <div class="sidebar-section-sep" />

    <!-- ── БАЗА ДАННЫХ ──────────────────────────────────── -->
    <el-menu-item-group>
      <template #title>{{$t("Menu.SectionData")}}</template>

      <el-tooltip :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('database.view')" placement="right" popper-style="max-width:240px">
        <el-menu-item id="tour-database-events" index="database-events" :class="{ 'sidebar-premium-item': isFreeTariff, 'menu-item-restricted': !can('database.view') }">
          <a class="menu-link-overlay" :href="resolveHref('/database/events')" @click="onMenuAnchorClick($event, '/database/events', 'database.view')"></a>
          <i class="fas fa-table"></i>
          <template #title>{{$t("Menu.DatabaseEvents")}}</template>
        </el-menu-item>
      </el-tooltip>

      <el-tooltip :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('database.view')" placement="right" popper-style="max-width:240px">
        <el-menu-item id="tour-database-messages" index="database-messages" :class="{ 'sidebar-premium-item': isFreeTariff, 'menu-item-restricted': !can('database.view') }">
          <a class="menu-link-overlay" :href="resolveHref('/database/messages')" @click="onMenuAnchorClick($event, '/database/messages', 'database.view')"></a>
          <i class="fas fa-comments"></i>
          <template #title>{{$t("Menu.DatabaseMessages")}}</template>
        </el-menu-item>
      </el-tooltip>
    </el-menu-item-group>

    <div class="sidebar-section-sep" />

    <!-- ── НАСТРОЙКИ ─────────────────────────────────────── -->
    <el-menu-item-group>
      <template #title>{{$t("Menu.SectionSettings")}}</template>

      <el-menu-item id="tour-resources" index="3" @mouseenter="openResourcesDropdown($event)" @mouseleave="closeResourcesDropdownWithDelay()">
        <a class="menu-link-overlay" :href="resolveHref('/resorces')" @click="onMenuAnchorClick($event, '/resorces')"></a>
        <i v-if="collapsed" class="fas fa-layer-group"></i>
        <div v-else class="hover-resources" ref="resourcesTrigger">
          <i class="fas fa-layer-group"></i>
          <span class="menu-title">{{$t("Menu.Bots")}}</span>
          <i class="fas submenu-caret ms-auto" :class="caretIconClass" aria-hidden="true"></i>
        </div>
      </el-menu-item>

      <el-menu-item id="tour-projects" index="projects">
        <a class="menu-link-overlay" :href="resolveHref('/projects')" @click="onMenuAnchorClick($event, '/projects')"></a>
        <i class="fas fa-folder-tree"></i>
        <template #title>{{$t("Menu.Projects")}}</template>
      </el-menu-item>

      <el-tooltip :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('webapp.view')" placement="right" popper-style="max-width:240px">
        <el-menu-item id="tour-webapp" index="9" :class="{ 'menu-item-restricted': !can('webapp.view') }">
          <a class="menu-link-overlay" :href="resolveHref('/webapps')" @click="onMenuAnchorClick($event, '/webapps', 'webapp.view')"></a>
          <i class="fa-solid fa-mobile-screen-button"></i>
          <template #title>{{$t("Menu.Webapp")}}</template>
        </el-menu-item>
      </el-tooltip>

      <el-tooltip :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('settings.view')" placement="right" popper-style="max-width:240px">
        <el-menu-item id="tour-codeforsite" index="6" :class="{ 'menu-item-restricted': !can('settings.view') }">
          <a class="menu-link-overlay" :href="resolveHref('/code4-site')" @click="onMenuAnchorClick($event, '/code4-site', 'settings.view')"></a>
          <i class="fas fa-code"></i>
          <template #title>{{$t("Menu.CodeForSite")}}</template>
        </el-menu-item>
      </el-tooltip>

      <el-tooltip :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('custom_fields.view')" placement="right" popper-style="max-width:240px">
        <el-menu-item index="11" :class="{ 'menu-item-restricted': !can('custom_fields.view') }">
          <a class="menu-link-overlay" :href="resolveHref('/custom-fields')" @click="onMenuAnchorClick($event, '/custom-fields', 'custom_fields.view')"></a>
          <i class="fas fa-tags"></i>
          <template #title>{{$t("Menu.CustomFields")}}</template>
        </el-menu-item>
      </el-tooltip>

      <el-tooltip :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('settings.view')" placement="right" popper-style="max-width:240px">
        <el-menu-item index="landings" :class="{ 'menu-item-restricted': !can('settings.view') }">
          <a class="menu-link-overlay" :href="resolveHref('/landings')" @click="onMenuAnchorClick($event, '/landings', 'settings.view')"></a>
          <i class="fas fa-link"></i>
          <template #title>
            {{$t("Menu.Landings")}}
          </template>
        </el-menu-item>
      </el-tooltip>

      <el-tooltip :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('settings.view')" placement="right" popper-style="max-width:240px">
        <el-menu-item index="public-stats" :class="{ 'menu-item-restricted': !can('settings.view') }">
          <a class="menu-link-overlay" :href="resolveHref('/public-stats')" @click="onMenuAnchorClick($event, '/public-stats', 'settings.view')"></a>
          <i class="fas fa-chart-simple"></i>
          <template #title>
            {{$t("Menu.PublicStats")}}
          </template>
        </el-menu-item>
      </el-tooltip>

      <el-tooltip :content="$t('General.ErrorsText.MenuItemNoPermission')" :disabled="can('errors.view')" placement="right" popper-style="max-width:240px">
        <el-menu-item index="7" :class="{ 'menu-item-restricted': !can('errors.view') }">
          <a class="menu-link-overlay" :href="resolveHref('/bot_errors')" @click="onMenuAnchorClick($event, '/bot_errors', 'errors.view')"></a>
          <i class="fas fa-bug"></i>
          <template #title>{{$t("Menu.BotErrors")}}</template>
        </el-menu-item>
      </el-tooltip>

    </el-menu-item-group>

    <div v-if="$store.state.init.user && $store.state.init.user.admin" class="sidebar-section-sep" />

    <!-- ── АДМИНКА ─────────────────────────────────────── -->
    <el-menu-item-group v-if="$store.state.init.user && $store.state.init.user.admin">
      <template #title>АДМИНКА</template>

      <el-menu-item index="admin-users">
        <a class="menu-link-overlay" :href="resolveHref('/admin/users')" @click="onMenuAnchorClick($event, '/admin/users')"></a>
        <i class="fas fa-users-cog"></i>
        <template #title>Пользователи</template>
      </el-menu-item>

      <el-menu-item index="admin-bots">
        <a class="menu-link-overlay" :href="resolveHref('/admin/bots')" @click="onMenuAnchorClick($event, '/admin/bots')"></a>
        <i class="fas fa-robot"></i>
        <template #title>Боты</template>
      </el-menu-item>

      <el-menu-item index="admin-billing">
        <a class="menu-link-overlay" :href="resolveHref('/admin/billing')" @click="onMenuAnchorClick($event, '/admin/billing')"></a>
        <i class="fas fa-money-bill-wave"></i>
        <template #title>Биллинг</template>
      </el-menu-item>

      <el-menu-item index="admin-billing-stats">
        <a class="menu-link-overlay" :href="resolveHref('/admin/billing-stats')" @click="onMenuAnchorClick($event, '/admin/billing-stats')"></a>
        <i class="fas fa-chart-line"></i>
        <template #title>Статистика списаний</template>
      </el-menu-item>

      <el-menu-item index="admin-usage">
        <a class="menu-link-overlay" :href="resolveHref('/admin/usage')" @click="onMenuAnchorClick($event, '/admin/usage')"></a>
        <i class="fas fa-chart-pie"></i>
        <template #title>Потребление</template>
      </el-menu-item>

      <el-menu-item index="admin-assistant">
        <a class="menu-link-overlay" :href="resolveHref('/admin/assistant')" @click="onMenuAnchorClick($event, '/admin/assistant')"></a>
        <i class="fas fa-robot"></i>
        <template #title>{{ $t('AssistantAdmin.Title') }}</template>
      </el-menu-item>

      <el-menu-item index="admin-payments">
        <a class="menu-link-overlay" :href="resolveHref('/admin/payments')" @click="onMenuAnchorClick($event, '/admin/payments')"></a>
        <i class="fas fa-file-invoice-dollar"></i>
        <template #title>Платежи</template>
      </el-menu-item>

      <el-menu-item index="admin-workflow-templates">
        <a class="menu-link-overlay" :href="resolveHref('/admin/workflow-templates')" @click="onMenuAnchorClick($event, '/admin/workflow-templates')"></a>
        <i class="fas fa-th-large"></i>
        <template #title>Каталог автоматизаций</template>
      </el-menu-item>

      <el-menu-item index="admin-tags">
        <a class="menu-link-overlay" :href="resolveHref('/admin/tags')" @click="onMenuAnchorClick($event, '/admin/tags')"></a>
        <i class="fas fa-tags"></i>
        <template #title>{{ $t('AdminTags.title') }}</template>
      </el-menu-item>
    </el-menu-item-group>

  </el-menu>

  <!-- Conversions hover dropdown -->
  <teleport to="body">
    <ul
      v-if="hoverConversions"
      class="dropdown-menu mt-0 sidebar-float-dropdown shadow rounded-3"
      :class="['show', ($store.state.theme.sidebarType === 'bg-default' || $store.state.theme.darkMode) ? 'dropdown-menu-dark' : '']"
      :style="{ top: dropdownConversionsPos.top, left: dropdownConversionsPos.left, right: dropdownConversionsPos.right }"
      @mouseenter="cancelCloseDropdown"
      @mouseleave="closeConversionsDropdownWithDelay"
    >
      <li>
        <a class="dropdown-item" :href="resolveHref('/conversion')" @click="onFlyoutAnchorClick($event, '/conversion')">
          <i class="fas fa-percentage me-2"></i>
          {{$t('Menu.ConversionsList')}}
        </a>
      </li>
      <li>
        <a class="dropdown-item" :href="resolveHref('/reports/conversion_summary')" @click="onFlyoutAnchorClick($event, '/reports/conversion_summary')">
          <i class="fas fa-chart-bar me-2"></i>
          {{$t('Menu.ConversionsSummary')}}
        </a>
      </li>
      <li>
        <a class="dropdown-item" :href="resolveHref({name: 'Targets'})" @click="onFlyoutAnchorClick($event, {name: 'Targets'})">
          <i class="fas fa-bullseye me-2"></i>
          {{$t('Menu.TargetSettings')}}
        </a>
      </li>
      <li>
        <a class="dropdown-item" :href="resolveHref({name: 'EventRules'})" @click="onFlyoutAnchorClick($event, {name: 'EventRules'})">
          <i class="fas fa-code-branch me-2"></i>
          {{$t('Menu.EventRules')}}
        </a>
      </li>
    </ul>
  </teleport>

  <!-- Referral hover dropdown -->
  <teleport to="body">
    <ul
      v-if="hoverReferral"
      class="dropdown-menu mt-0 sidebar-float-dropdown shadow rounded-3"
      :class="['show', ($store.state.theme.sidebarType === 'bg-default' || $store.state.theme.darkMode) ? 'dropdown-menu-dark' : '']"
      :style="{ top: dropdownReferralPos.top, left: dropdownReferralPos.left, right: dropdownReferralPos.right }"
      @mouseenter="cancelCloseDropdown"
      @mouseleave="closeReferralDropdownWithDelay"
    >
      <li v-for="item in referralMenu" :key="item.key">
        <a
          v-if="item.route"
          class="dropdown-item"
          :href="resolveHref(item.route)"
          @click="onFlyoutAnchorClick($event, item.route)"
        >
          <i class="fas me-2" :class="item.icon"></i>
          {{ $t(item.labelKey) }}
        </a>
        <span v-else class="dropdown-item dropdown-item--soon d-flex align-items-center">
          <i class="fas me-2" :class="item.icon"></i>
          {{ $t(item.labelKey) }}
          <span class="ptag ptag--sm ms-auto">{{ $t('Menu.ReferralSub.Soon') }}</span>
        </span>
      </li>
    </ul>
  </teleport>

  <!-- Ads hover dropdown -->
  <teleport to="body">
    <ul
      v-if="hoverAds"
      class="dropdown-menu mt-0 sidebar-float-dropdown shadow rounded-3"
      :class="['show', ($store.state.theme.sidebarType === 'bg-default' || $store.state.theme.darkMode) ? 'dropdown-menu-dark' : '']"
      :style="{ top: dropdownAdsPos.top, left: dropdownAdsPos.left, right: dropdownAdsPos.right }"
      @mouseenter="cancelCloseDropdown"
      @mouseleave="closeAdsDropdownWithDelay"
    >
      <li v-for="item in adsMenu" :key="item.key">
        <a
          v-if="item.route"
          class="dropdown-item"
          :href="resolveHref(item.route)"
          @click="onFlyoutAnchorClick($event, item.route)"
        >
          <i class="fas me-2" :class="item.icon"></i>
          {{ $t(item.labelKey) }}
        </a>
        <span v-else class="dropdown-item dropdown-item--soon d-flex align-items-center">
          <i class="fas me-2" :class="item.icon"></i>
          {{ $t(item.labelKey) }}
          <span class="ptag ptag--sm ms-auto">{{ $t('Menu.ReferralSub.Soon') }}</span>
        </span>
      </li>
    </ul>
  </teleport>

  <!-- Teleported submenu to avoid clipping by sidebar containers -->
  <teleport to="body">
    <ul
      v-if="hoverResources"
      class="dropdown-menu mt-0 sidebar-float-dropdown shadow rounded-3"
      :class="['show', ($store.state.theme.sidebarType === 'bg-default' || $store.state.theme.darkMode) ? 'dropdown-menu-dark' : '']"
      :style="{ top: dropdownPos.top, left: dropdownPos.left, right: dropdownPos.right }"
      @mouseenter="cancelCloseDropdown"
      @mouseleave="closeResourcesDropdownWithDelay"
    >
      <li>
        <a class="dropdown-item" :href="resolveHref('/resorces/connect')" @click="onFlyoutAnchorClick($event, '/resorces/connect')">
          <i class="fas fa-plus me-2"></i>
          {{$t('General.Bots.AddResource')}}
        </a>
      </li>
      <li>
        <a class="dropdown-item" :href="resolveHref('/resorces')" @click="onFlyoutAnchorClick($event, '/resorces')">
          <i class="fas fa-layer-group me-2"></i>
          {{$t('Menu.Bots')}}
        </a>
      </li>
    </ul>
  </teleport>

  <!-- Dashboards hover flyout panel -->
  <teleport to="body">
    <div
      v-if="hoverDashboards"
      class="dashboards-float-panel"
      :class="{ 'dashboards-panel-dark': $store.state.theme.sidebarType === 'bg-default' || $store.state.theme.darkMode }"
      :style="{ top: dropdownDashboardsPos.top, left: dropdownDashboardsPos.left, right: dropdownDashboardsPos.right }"
      @mouseenter="cancelCloseDropdown"
      @mouseleave="closeDashboardsDropdownWithDelay"
    >
      <!-- Search -->
      <div class="dfp-search-row">
        <i class="fas fa-search dfp-search-icon"></i>
        <input
          v-model="dashboardsSearchQuery"
          class="dfp-search"
          :placeholder="$t('Menu.DashboardsSearch')"
          @click.stop
        />
      </div>

      <!-- List -->
      <div class="dfp-items-scroll">
        <!-- Loading -->
        <div v-if="dashboardsLoading" class="dfp-state-msg">
          <i class="fas fa-circle-notch fa-spin me-2"></i>
        </div>

        <!-- Items -->
        <template v-else>
          <a
            v-for="d in visibleDashboards"
            :key="d.uuid"
            class="dfp-item"
            :href="resolveHref('/dashboards/' + d.uuid)"
            @click="onFlyoutAnchorClick($event, '/dashboards/' + d.uuid)"
          >
            <span class="dfp-item-icon-wrap">
              <i class="fas fa-th-large"></i>
            </span>
            <span class="dfp-item-text">
              <span class="dfp-item-name">{{ d.name || '—' }}</span>
              <span v-if="d.description" class="dfp-item-desc">{{ d.description }}</span>
            </span>
          </a>

          <div v-if="visibleDashboards.length === 0" class="dfp-state-msg">
            {{ dashboardsSearchQuery ? $t('Menu.DashboardsNoResults') : $t('Dashboards.hint') }}
          </div>
        </template>
      </div>

      <!-- Footer -->
      <div class="dfp-footer">
        <a class="dfp-footer-link" :href="resolveHref('/dashboards')" @click="onFlyoutAnchorClick($event, '/dashboards')">
          <i class="fas fa-th-list me-1"></i>
          {{ $t('Menu.DashboardsList') }}
        </a>
        <a class="dfp-footer-link dfp-footer-create" :href="resolveHref('/dashboards/new')" @click="onFlyoutAnchorClick($event, '/dashboards/new')">
          <i class="fas fa-plus me-1"></i>
          {{ $t('Menu.CreateDashboard') }}
        </a>
      </div>
    </div>
  </teleport>

  <!-- Large Reports panel: Metrica-style categories + items list -->
  <teleport to="body">
    <div
      v-if="hoverReports"
      class="reports-float-panel"
      :class="{ 'reports-panel-dark': $store.state.theme.sidebarType === 'bg-default' || $store.state.theme.darkMode }"
      :style="{ top: dropdownReportsPos.top, left: dropdownReportsPos.left, right: dropdownReportsPos.right }"
      @mouseenter="cancelCloseDropdown"
      @mouseleave="closeReportsDropdownWithDelay"
    >
      <div class="rfp-layout">
        <!-- Left: categories nav -->
        <div class="rfp-nav">
          <div
            v-for="cat in reportCategories"
            :key="cat.key"
            class="rfp-nav-item"
            :class="{ active: selectedCategory === cat.key }"
            @click="selectedCategory = cat.key; searchQuery = ''"
          >
            <i :class="'fas ' + cat.icon + ' rfp-nav-icon'"></i>
            <span>{{ $t(cat.labelKey) }}</span>
            <span v-if="cat.count > 0" class="rfp-nav-count">{{ cat.count }}</span>
          </div>

          <div class="rfp-nav-separator"></div>

          <a class="rfp-nav-item rfp-nav-action" :href="resolveHref('/user-reports')" @click="onFlyoutAnchorClick($event, '/user-reports')">
            <i class="fas fa-list rfp-nav-icon"></i>
            <span>{{ $t('Menu.ReportsList') }}</span>
          </a>

          <a class="rfp-nav-item rfp-nav-builder" :href="resolveHref('/report-builder')" @click="onFlyoutAnchorClick($event, '/report-builder')">
            <i class="fas fa-plus rfp-nav-icon"></i>
            <span>{{ $t('Menu.CreateReport') }}</span>
          </a>
        </div>

        <!-- Right: search + items -->
        <div class="rfp-content">
          <div class="rfp-search-row">
            <i class="fas fa-search rfp-search-icon"></i>
            <input
              v-model="searchQuery"
              class="rfp-search"
              :placeholder="$t('Menu.ReportsSearch')"
              @click.stop
            />
          </div>

          <div class="rfp-items-scroll">
            <!-- Loading state -->
            <div v-if="userReportsLoading && selectedCategory !== 'fixed'" class="rfp-state-msg">
              <i class="fas fa-circle-notch fa-spin me-2"></i>
            </div>

            <!-- User reports (all categories except fixed) -->
            <template v-else-if="selectedCategory !== 'fixed'">
              <a
                v-for="r in visibleUserReports"
                :key="r.uuid"
                class="rfp-item"
                :href="resolveHref('/user-reports/view/' + r.uuid)"
                @click="onFlyoutAnchorClick($event, '/user-reports/view/' + r.uuid)"
              >
                <span class="rfp-item-icon-wrap">
                  <i :class="'fas ' + getTypeIcon(r.type)"></i>
                </span>
                <span class="rfp-item-text">
                  <span class="rfp-item-name-row">
                    <span class="rfp-item-name">{{ getReportName(r) }}</span>
                    <i
                      v-if="r.is_system === 1 && r.is_free !== 1"
                      class="fas fa-crown rfp-premium-badge"
                      :title="$t('UserReports.badges.premiumTooltip')"
                    ></i>
                  </span>
                  <span class="rfp-item-desc">{{ getTypeName(r.type) }}</span>
                </span>
              </a>
              <div v-if="visibleUserReports.length === 0" class="rfp-state-msg">
                {{ searchQuery ? $t('Menu.ReportsNoResults') : $t('UserReports.hint') }}
              </div>
              <!-- "All reports" link at bottom when no search -->
              <a v-if="!searchQuery" class="rfp-item rfp-item-all" :href="resolveHref('/user-reports')" @click="onFlyoutAnchorClick($event, '/user-reports')">
                <span class="rfp-item-icon-wrap"><i class="fas fa-th-list"></i></span>
                <span class="rfp-item-text">
                  <span class="rfp-item-name">{{ $t('Menu.ReportsList') }}</span>
                </span>
              </a>
            </template>

            <!-- Fixed / legacy reports: shown in 'fixed' tab or included in 'all' view -->
            <template v-if="selectedCategory === 'fixed' || selectedCategory === 'all'">
              <a
                v-for="r in visibleFixedReports"
                :key="r.route"
                class="rfp-item"
                :href="resolveHref(r.route)"
                @click="onFlyoutAnchorClick($event, r.route)"
              >
                <span class="rfp-item-icon-wrap">
                  <i :class="'fas ' + r.icon"></i>
                </span>
                <span class="rfp-item-text">
                  <span class="rfp-item-name">{{ $t(r.nameKey) }}</span>
                  <span class="rfp-item-desc">{{ $t(r.descKey) }}</span>
                </span>
              </a>
              <div v-if="visibleFixedReports.length === 0 && selectedCategory === 'fixed'" class="rfp-state-msg">
                {{ $t('Menu.ReportsNoResults') }}
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </teleport>

</template>
<script>
import {
  Location,
  DataBoard
} from '@element-plus/icons-vue'
import {ElMessage} from 'element-plus'
import userReportService from '@/helpers/api/userReport.service'
import dashboardsService from '@/helpers/api/dashboards.service'

const USER_REPORTS_CACHE_KEY = 'sidebar_user_reports_cache';
const USER_REPORTS_CACHE_TTL = 5 * 60 * 1000; // 5 minutes

const DASHBOARDS_CACHE_KEY = 'sidebar_dashboards_cache';
const DASHBOARDS_CACHE_TTL = 5 * 60 * 1000; // 5 minutes

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
    collapsed: { type: Boolean, default: false }
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active",
      // Bots dropdown
      hoverResources: false,
      dropdownPos: { top: 0, left: null, right: null },
      // Conversions dropdown
      hoverConversions: false,
      dropdownConversionsPos: { top: 0, left: null, right: null },
      // Ads dropdown
      hoverAds: false,
      dropdownAdsPos: { top: 0, left: null, right: null },
      adsMenu: [
        { key: 'report',    labelKey: 'Menu.AdsSub.Report',    icon: 'fa-chart-column', route: '/ads/report' },
        { key: 'accounts',  labelKey: 'Menu.AdsSub.Accounts',  icon: 'fa-id-card',      route: '/ads/accounts' },
        { key: 'campaigns', labelKey: 'Menu.AdsSub.Campaigns', icon: 'fa-rectangle-ad', route: '/ads/campaigns' },
      ],
      // Referral dropdown
      hoverReferral: false,
      dropdownReferralPos: { top: 0, left: null, right: null },
      referralMenu: [
        { key: 'overview',   labelKey: 'Menu.ReferralSub.Overview',   icon: 'fa-chart-line',     route: '/referral' },
        { key: 'settings',   labelKey: 'Menu.ReferralSub.Settings',   icon: 'fa-sliders',        route: '/referral/settings' },
        { key: 'referrers',  labelKey: 'Menu.ReferralSub.Referrers',  icon: 'fa-user-group',     route: '/referral/referrers' },
        { key: 'referrals',  labelKey: 'Menu.ReferralSub.Referrals',  icon: 'fa-users',          route: '/referral/referrals' },
        { key: 'accruals',   labelKey: 'Menu.ReferralSub.Accruals',   icon: 'fa-coins',          route: '/referral/accruals' },
        { key: 'payouts',    labelKey: 'Menu.ReferralSub.Payouts',    icon: 'fa-money-bill-wave', route: '/referral/payouts' },
        { key: 'stats',      labelKey: 'Menu.ReferralSub.Stats',      icon: 'fa-chart-pie',      route: null }
      ],
      // Reports dropdown
      hoverReports: false,
      dropdownReportsPos: { top: 0, left: null, right: null },
      // User reports list
      userReports: [],
      userReportsLoading: false,
      closeTimer: null,
      // Panel state
      selectedCategory: 'all',
      searchQuery: '',
      // Dashboards dropdown
      hoverDashboards: false,
      dropdownDashboardsPos: { top: 0, left: null, right: null },
      dashboards: [],
      dashboardsLoading: false,
      dashboardsSearchQuery: ''
    };
  },
  components: {
    Location,
    DataBoard
  },
  mounted() {
    this.loadUserReports();
    this.loadDashboards();
  },
  watch: {
    '$store.state.init.user'(user) {
      if (!user) return;
      if (this.userReports.length === 0) this.loadUserReports();
      if (this.dashboards.length === 0) this.loadDashboards();
    }
  },
  methods: {
    // Whether the current user may use a menu section gated by this perm_key on the current
    // bot — owners/admins always pass, see store/modules/init.js `can` getter for the full rule.
    can(permKey) {
      return this.$store.getters['init/can'](permKey);
    },
    showAccessDeniedMessage() {
      ElMessage({
        message: this.$t('General.ErrorsText.MenuItemNoPermission'),
        type: 'warning'
      });
    },
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    goAndHide(path) {
      this.$router.push(path);
      this.$store.commit('theme/navbarHidden');
      this.hoverResources = false;
      this.hoverReports = false;
      this.hoverConversions = false;
      this.hoverDashboards = false;
      this.hoverReferral = false;
      this.hoverAds = false;
    },
    // Resolves a path or a { name: ... } route location to a real href, respecting the
    // router's base — used so sidebar items are real <a href> and support middle-click /
    // ctrl-click "open in new tab" instead of only working via a JS click handler.
    resolveHref(target) {
      try {
        return this.$router.resolve(target).href;
      } catch (_) {
        return typeof target === 'string' ? target : '#';
      }
    },
    // True for a plain left click with no modifier keys — i.e. the browser should NOT
    // handle it natively (no new tab), so we take over with router.push.
    navIntent(e) {
      return !(e.metaKey || e.ctrlKey || e.shiftKey || (typeof e.button === 'number' && e.button !== 0));
    },
    // Click handler for the invisible <a> overlay stretched over an el-menu-item. Left-clicks
    // are intercepted (permission-gated) and routed via goAndHide; modifier/middle clicks are
    // left alone so the browser opens the real href in a new tab.
    onMenuAnchorClick(e, target, permKey) {
      if (!this.navIntent(e)) return;
      e.preventDefault();
      if (permKey && !this.can(permKey)) {
        this.showAccessDeniedMessage();
        return;
      }
      this.goAndHide(target);
    },
    // Same idea for the teleported flyout panels' <a href="#"> items.
    onFlyoutAnchorClick(e, target) {
      e.stopPropagation();
      if (!this.navIntent(e)) return;
      e.preventDefault();
      this.goAndHide(target);
    },
    // ─── Dashboards dropdown ──────────────────────────────────────
    openDashboardsDropdown(event) {
      // Silent guard: the item's own click handler already shows the "no permission"
      // message, this only stops the hover flyout (with its data fetch) from opening too.
      if (!this.can('report.view')) return;
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
      this.hoverResources = false;
      this.hoverReports = false;
      this.hoverConversions = false;

      const el = this.$refs.dashboardsTrigger || event?.currentTarget;
      if (!el) { this.hoverDashboards = true; return; }
      const rect = el.getBoundingClientRect();
      const isRTL = this.$store.state.theme.isRTL;
      const PANEL_WIDTH = 320;
      const pos = { top: Math.max(0, rect.top) + 'px', left: null, right: null };
      if (isRTL) {
        pos.right = Math.max(0, window.innerWidth - rect.left) + 4 + 'px';
      } else {
        let left = rect.right + 4;
        if (left + PANEL_WIDTH > window.innerWidth) {
          left = Math.max(0, window.innerWidth - PANEL_WIDTH - 8);
        }
        pos.left = left + 'px';
      }
      this.dropdownDashboardsPos = pos;
      this.hoverDashboards = true;
    },
    closeDashboardsDropdownWithDelay() {
      if (this.closeTimer) clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => { this.hoverDashboards = false; }, 120);
    },
    // ─── Dashboards data ──────────────────────────────────────────
    async loadDashboards() {
      if (!this.$store.state.init.user) return;
      try {
        const raw = localStorage.getItem(DASHBOARDS_CACHE_KEY);
        if (raw) {
          const { data, ts } = JSON.parse(raw);
          if (Date.now() - ts < DASHBOARDS_CACHE_TTL) {
            this.dashboards = data;
            return;
          }
        }
      } catch (_) { /* ignore */ }

      this.dashboardsLoading = true;
      try {
        const data = await dashboardsService.index();
        this.dashboards = Array.isArray(data) ? data : [];
        try {
          localStorage.setItem(DASHBOARDS_CACHE_KEY, JSON.stringify({
            data: this.dashboards,
            ts: Date.now()
          }));
        } catch (_) { /* quota exceeded */ }
      } catch (_) {
        this.dashboards = [];
      } finally {
        this.dashboardsLoading = false;
      }
    },
    // ─── Conversions dropdown ─────────────────────────────────────
    openConversionsDropdown(event) {
      if (!this.can('report.view')) return;
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
      this.hoverResources = false;
      this.hoverReports = false;

      const el = this.$refs.conversionsTrigger || event?.currentTarget;
      if (!el) { this.hoverConversions = true; return; }
      const rect = el.getBoundingClientRect();
      const isRTL = this.$store.state.theme.isRTL;
      const pos = { top: Math.max(0, rect.top) + 'px', left: null, right: null };
      if (isRTL) {
        pos.right = Math.max(0, window.innerWidth - rect.left) + 4 + 'px';
      } else {
        pos.left = Math.max(0, rect.right) + 4 + 'px';
      }
      this.dropdownConversionsPos = pos;
      this.hoverConversions = true;
    },
    closeConversionsDropdownWithDelay() {
      if (this.closeTimer) clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => { this.hoverConversions = false; }, 120);
    },
    // ─── Referral dropdown ────────────────────────────────────────
    openReferralDropdown(event) {
      if (!this.can('report.view')) return;
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
      this.hoverResources = false;
      this.hoverReports = false;
      this.hoverConversions = false;
      this.hoverDashboards = false;

      const el = this.$refs.referralTrigger || event?.currentTarget;
      if (!el) { this.hoverReferral = true; return; }
      const rect = el.getBoundingClientRect();
      const isRTL = this.$store.state.theme.isRTL;
      const pos = { top: Math.max(0, rect.top) + 'px', left: null, right: null };
      if (isRTL) {
        pos.right = Math.max(0, window.innerWidth - rect.left) + 4 + 'px';
      } else {
        pos.left = Math.max(0, rect.right) + 4 + 'px';
      }
      this.dropdownReferralPos = pos;
      this.hoverReferral = true;
    },
    closeReferralDropdownWithDelay() {
      if (this.closeTimer) clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => { this.hoverReferral = false; }, 120);
    },
    // ─── Ads dropdown ─────────────────────────────────────────────
    openAdsDropdown(event) {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
      this.hoverResources = false;
      this.hoverReports = false;
      this.hoverConversions = false;
      this.hoverDashboards = false;
      this.hoverReferral = false;

      const el = this.$refs.adsTrigger || event?.currentTarget;
      if (!el) { this.hoverAds = true; return; }
      const rect = el.getBoundingClientRect();
      const isRTL = this.$store.state.theme.isRTL;
      const pos = { top: Math.max(0, rect.top) + 'px', left: null, right: null };
      if (isRTL) {
        pos.right = Math.max(0, window.innerWidth - rect.left) + 4 + 'px';
      } else {
        pos.left = Math.max(0, rect.right) + 4 + 'px';
      }
      this.dropdownAdsPos = pos;
      this.hoverAds = true;
    },
    closeAdsDropdownWithDelay() {
      if (this.closeTimer) clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => { this.hoverAds = false; }, 120);
    },
    // ─── Bots dropdown ───────────────────────────────────────────
    openResourcesDropdown(event) {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
      this.hoverReports = false;
      this.hoverConversions = false;

      const el = this.$refs.resourcesTrigger || event?.currentTarget;
      if (!el) { this.hoverResources = true; return; }
      const rect = el.getBoundingClientRect();
      const isRTL = this.$store.state.theme.isRTL;
      const pos = { top: Math.max(0, rect.top) + 'px', left: null, right: null };
      if (isRTL) {
        pos.right = Math.max(0, window.innerWidth - rect.left) + 4 + 'px';
      } else {
        pos.left = Math.max(0, rect.right) + 4 + 'px';
      }
      this.dropdownPos = pos;
      this.hoverResources = true;
    },
    closeResourcesDropdownWithDelay() {
      if (this.closeTimer) clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => { this.hoverResources = false; }, 120);
    },
    cancelCloseDropdown() {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
    },
    // ─── Reports dropdown ─────────────────────────────────────────
    openReportsFixed(event) {
      // This item doesn't navigate anywhere itself (just opens the flyout), so it needs
      // its own explicit denial message instead of going through onMenuAnchorClick.
      if (!this.can('report.view')) { this.showAccessDeniedMessage(); return; }
      this.selectedCategory = 'fixed';
      this.openReportsDropdown(event, event?.currentTarget);
    },
    openReportsDropdown(event, overrideEl) {
      // Silent guard here too — this is also reached via the Reports item's mouseenter.
      if (!this.can('report.view')) return;
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
      this.hoverResources = false;
      this.hoverConversions = false;

      const el = overrideEl || this.$refs.reportsTrigger || event?.currentTarget;
      if (!el) { this.hoverReports = true; return; }
      const rect = el.getBoundingClientRect();
      const isRTL = this.$store.state.theme.isRTL;
      const PANEL_WIDTH = 720;
      const panelHeight = window.innerHeight - 48;
      const idealTop = rect.top;
      const top = Math.min(idealTop, window.innerHeight - panelHeight - 16);
      const pos = { top: Math.max(8, top) + 'px', left: null, right: null };
      if (isRTL) {
        pos.right = Math.max(0, window.innerWidth - rect.left) + 4 + 'px';
      } else {
        let left = rect.right + 4;
        // Prevent overflow on the right edge
        if (left + PANEL_WIDTH > window.innerWidth) {
          left = Math.max(0, window.innerWidth - PANEL_WIDTH - 8);
        }
        pos.left = left + 'px';
      }
      this.dropdownReportsPos = pos;
      this.hoverReports = true;
    },
    closeReportsDropdownWithDelay() {
      if (this.closeTimer) clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => { this.hoverReports = false; }, 120);
    },
    // ─── User reports data ────────────────────────────────────────
    async loadUserReports() {
      if (!this.$store.state.init.user) return;
      // Try localStorage cache first
      try {
        const raw = localStorage.getItem(USER_REPORTS_CACHE_KEY);
        if (raw) {
          const { data, ts } = JSON.parse(raw);
          if (Date.now() - ts < USER_REPORTS_CACHE_TTL) {
            this.userReports = data;
            return;
          }
        }
      } catch (_) { /* ignore */ }

      this.userReportsLoading = true;
      try {
        const data = await userReportService.index();
        this.userReports = Array.isArray(data) ? data : [];
        try {
          localStorage.setItem(USER_REPORTS_CACHE_KEY, JSON.stringify({
            data: this.userReports,
            ts: Date.now()
          }));
        } catch (_) { /* quota exceeded, skip */ }
      } catch (_) {
        this.userReports = [];
      } finally {
        this.userReportsLoading = false;
      }
    },
    getReportName(report) {
      const locale = this.$i18n?.locale || 'ru';
      return report.translations?.[locale]?.name
        ?? report.translations?.['en']?.name
        ?? report.name
        ?? '—';
    },
    getTypeIcon(type) {
      const map = { trends: 'fa-chart-line', list: 'fa-table', funnel: 'fa-filter', retention: 'fa-redo-alt' };
      return map[type] || 'fa-chart-bar';
    },
    getTypeName(type) {
      const map = { trends: this.$t('Menu.TypeTrends'), list: this.$t('Menu.TypeTable'), funnel: this.$t('Menu.TypeFunnel'), retention: this.$t('Menu.TypeRetention') };
      return map[type] || type || '';
    }
  },
  beforeUnmount() {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  },
  computed: {
    isChannel() {
      return this.$store?.state?.init?.current_bot?.type === 2;
    },
    // Каналы (2) и группы (3) — всё, что подключено общим канальным ботом. Именно у них
    // бывают пригласительные ссылки с подтверждением; у бота в личке (1) — нет.
    hasJoinRequests() {
      const type = this.$store?.state?.init?.current_bot?.type;
      return type === 2 || type === 3;
    },
    isFreeTariff() {
      const bot = this.$store?.state?.init?.current_bot;
      return !bot || !bot.tariff;
    },
    caretIconClass() {
      if (this.hoverResources) return 'fa-angle-down';
      return this.$store.state.theme.isRTL ? 'fa-angle-left' : 'fa-angle-right';
    },
    conversionsCaretIconClass() {
      if (this.hoverConversions) return 'fa-angle-down';
      return this.$store.state.theme.isRTL ? 'fa-angle-left' : 'fa-angle-right';
    },
    referralCaretIconClass() {
      if (this.hoverReferral) return 'fa-angle-down';
      return this.$store.state.theme.isRTL ? 'fa-angle-left' : 'fa-angle-right';
    },
    adsCaretIconClass() {
      if (this.hoverAds) return 'fa-angle-down';
      return this.$store.state.theme.isRTL ? 'fa-angle-left' : 'fa-angle-right';
    },
    reportsCaretIconClass() {
      if (this.hoverReports) return 'fa-angle-down';
      return this.$store.state.theme.isRTL ? 'fa-angle-left' : 'fa-angle-right';
    },
    dashboardsCaretIconClass() {
      if (this.hoverDashboards) return 'fa-angle-down';
      return this.$store.state.theme.isRTL ? 'fa-angle-left' : 'fa-angle-right';
    },
    visibleDashboards() {
      const q = this.dashboardsSearchQuery.trim().toLowerCase();
      if (!q) return this.dashboards;
      return this.dashboards.filter(d => (d.name || '').toLowerCase().includes(q));
    },
    // All fixed (legacy) reports as flat list with metadata
    allFixedReports() {
      const reports = [];
      if (!this.isChannel) {
        reports.push(
          { route: '/reports/active_users?details=month', icon: 'fa-users', nameKey: 'Menu.ActiveUsersMAU', descKey: 'Menu.FixedDesc.ActiveUsers' },
          { route: '/reports/active_users?details=week',  icon: 'fa-users', nameKey: 'Menu.ActiveUsersWAU', descKey: 'Menu.FixedDesc.ActiveUsers' },
          { route: '/reports/active_users?details=day',   icon: 'fa-users', nameKey: 'Menu.ActiveUsersDAU', descKey: 'Menu.FixedDesc.ActiveUsers' },
        );
      }
      reports.push(
        { route: '/reports/messages_from_user', icon: 'fa-comments',    nameKey: 'Menu.TotalReceivedMessages', descKey: 'Menu.FixedDesc.Messages' },
      );
      if (!this.isChannel) {
        reports.push(
          { route: '/reports/rejection',         icon: 'fa-door-open',  nameKey: 'Menu.Rejection',            descKey: 'Menu.FixedDesc.Rejection' },
        );
      }
      reports.push(
        { route: '/reports/utm_summary',         icon: 'fa-link',       nameKey: 'Menu.UtmSummary',           descKey: 'Menu.FixedDesc.Utm' },
        { route: '/reports/new_users',           icon: 'fa-user-plus',  nameKey: 'Menu.NewUsers',             descKey: 'Menu.FixedDesc.Users' },
        { route: '/reports/left_users',          icon: 'fa-user-minus', nameKey: 'Menu.LeftUsers',            descKey: 'Menu.FixedDesc.Users' },
        { route: '/reports/return_users',        icon: 'fa-user-clock', nameKey: 'Menu.ReturnUsers',          descKey: 'Menu.FixedDesc.Users' },
      );
      if (!this.isChannel) {
        reports.push(
          { route: '/reports/app_session_source',  icon: 'fa-mobile-alt', nameKey: 'Menu.AppSessionsSource',  descKey: 'Menu.FixedDesc.Sessions' },
          { route: '/reports/app_session_device',  icon: 'fa-tablet-alt', nameKey: 'Menu.AppSessionsDevice',  descKey: 'Menu.FixedDesc.Sessions' },
          { route: '/reports/app_session_version', icon: 'fa-code-branch',nameKey: 'Menu.AppSessionsVersion', descKey: 'Menu.FixedDesc.Sessions' },
          { route: '/reports/session_count',       icon: 'fa-layer-group',nameKey: 'Menu.Sessions',           descKey: 'Menu.FixedDesc.Sessions' },
          { route: '/reports/avg_events_session',  icon: 'fa-bolt',       nameKey: 'Menu.AvgEventsSession',   descKey: 'Menu.FixedDesc.Sessions' },
          { route: '/reports/avg_duration_session',icon: 'fa-stopwatch',  nameKey: 'Menu.AvgDurationSession', descKey: 'Menu.FixedDesc.Sessions' },
        );
      }
      return reports;
    },
    visibleFixedReports() {
      const q = this.searchQuery.trim().toLowerCase();
      if (!q) return this.allFixedReports;
      return this.allFixedReports.filter(r => this.$t(r.nameKey).toLowerCase().includes(q));
    },
    visibleUserReports() {
      let list = this.userReports;
      if (this.selectedCategory === 'mine') {
        list = list.filter(r => !r.is_system);
      } else if (this.selectedCategory !== 'all') {
        list = list.filter(r => r.type === this.selectedCategory);
      }
      const q = this.searchQuery.trim().toLowerCase();
      if (q) {
        list = list.filter(r => this.getReportName(r).toLowerCase().includes(q));
      }
      return list;
    },
    reportCategories() {
      const types = ['trends', 'list', 'funnels', 'retention'];
      const iconMap = { trends: 'fa-chart-line', list: 'fa-table', funnels: 'fa-filter', retention: 'fa-redo-alt' };
      const labelMap = { trends: 'Menu.TypeTrends', list: 'Menu.TypeTable', funnels: 'Menu.TypeFunnel', retention: 'Menu.TypeRetention' };
      const cats = [
        { key: 'all',   icon: 'fa-th-large',  labelKey: 'Menu.AllReports',   count: 0 },
        { key: 'mine',  icon: 'fa-user',      labelKey: 'Menu.MyReports',    count: this.userReports.filter(r => !r.is_system).length },
        ...types.map(t => ({
          key: t,
          icon: iconMap[t],
          labelKey: labelMap[t],
          count: this.userReports.filter(r => r.type === t).length
        })),
        { key: 'fixed', icon: 'fa-archive',   labelKey: 'Menu.FixedReports', count: 0 },
      ];
      return cats;
    }
  }
};
</script>
<style>
.el-sub-menu .el-menu-item {
  line-height: 40px !important;
  height: 40px !important;
}

/* Real <a href> stretched over the whole menu item so it behaves like a normal link
   (middle-click / ctrl-click open a new tab) while the visible icon/title keep their
   original layout; plain left-clicks are still intercepted in JS for SPA navigation. */
#sidenav-main .el-menu-item {
  position: relative;
}
#sidenav-main .menu-link-overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
}

/* Hover submenu shared layout */
.hover-resources {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 100%;
}

/* Existing small floating dropdown (Bots) */
.sidebar-float-dropdown.dropdown-menu {
  display: block;
  position: fixed;
  z-index: 3000;
  min-width: 200px;
  box-shadow: 0 0 0 1px rgba(0,0,0,.06), 0 .5rem 1rem rgba(0,0,0,.15);
  border: 1px solid rgba(0,0,0,.08);
  background-clip: padding-box;
}
.dropdown-menu-dark.sidebar-float-dropdown {
  border-color: rgba(255,255,255,.1);
}

/* Premium-only marker for free-tariff users */
.el-menu-item.sidebar-premium-item {
  background-color: rgba(255, 193, 7, 0.12);
}
.el-menu-item.sidebar-premium-item:hover {
  background-color: rgba(255, 193, 7, 0.2);
}

/* Items the current user lacks a perm_key for: still visible and clickable (click shows
   a "request access from the owner" message instead of navigating), just visibly muted. */
.el-menu-item.menu-item-restricted {
  opacity: 0.45;
  cursor: not-allowed;
}
.el-menu-item.menu-item-restricted:hover {
  background-color: transparent !important;
}

/* Caret indicator */
.submenu-caret {
  font-size: 0.8rem;
  opacity: .6;
  transition: transform .15s ease, opacity .2s;
}
.el-menu-item:hover .submenu-caret,
.hover-resources:hover .submenu-caret {
  opacity: .95;
}

/* ─── Reports Float Panel ─────────────────────────────────────── */
.reports-float-panel {
  position: fixed;
  z-index: 3000;
  background: #fff;
  border: 1px solid rgba(0,0,0,.08);
  border-radius: 10px;
  box-shadow: 0 0 0 1px rgba(0,0,0,.05), 0 8px 32px rgba(0,0,0,.16);
  width: 680px;
  max-width: calc(100vw - 24px);
  font-size: 14px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.reports-panel-dark {
  background: #1e1e2e;
  border-color: rgba(255,255,255,.1);
  color: #d0d0e0;
}

/* Two-column layout */
.rfp-layout {
  display: flex;
  height: calc(100vh - 48px);
  overflow: hidden;
}

/* ── Left nav column ── */
.rfp-nav {
  width: 180px;
  flex-shrink: 0;
  background: #f8f9fa;
  border-right: 1px solid rgba(0,0,0,.07);
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
.reports-panel-dark .rfp-nav {
  background: #16162a;
  border-right-color: rgba(255,255,255,.07);
}
.rfp-nav-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  cursor: pointer;
  border-radius: 0;
  transition: background .12s, color .12s;
  font-size: 13.5px;
  color: #555;
  position: relative;
  user-select: none;
}
.reports-panel-dark .rfp-nav-item { color: #aaa; }
.rfp-nav-item:hover {
  background: rgba(94,114,228,.08);
  color: #5e72e4;
}
.reports-panel-dark .rfp-nav-item:hover {
  background: rgba(130,94,228,.15);
  color: #a78bfa;
}
.rfp-nav-item.active {
  background: #fff;
  color: #5e72e4;
  font-weight: 600;
  border-right: 2px solid #5e72e4;
}
.reports-panel-dark .rfp-nav-item.active {
  background: #1e1e2e;
  color: #a78bfa;
  border-right-color: #a78bfa;
}
.rfp-nav-icon {
  width: 14px;
  text-align: center;
  opacity: .7;
  font-size: 12px;
  flex-shrink: 0;
}
.rfp-nav-count {
  margin-left: auto;
  font-size: 11px;
  background: rgba(94,114,228,.12);
  color: #5e72e4;
  border-radius: 10px;
  padding: 1px 6px;
  font-weight: 600;
}
.reports-panel-dark .rfp-nav-count {
  background: rgba(130,94,228,.2);
  color: #a78bfa;
}
.rfp-nav-separator {
  height: 1px;
  background: rgba(0,0,0,.07);
  margin: 6px 10px;
}
.reports-panel-dark .rfp-nav-separator {
  background: rgba(255,255,255,.07);
}
.rfp-nav-action {
  color: #5e72e4 !important;
  font-weight: 600;
}
.reports-panel-dark .rfp-nav-action {
  color: #a78bfa !important;
}
.rfp-nav-action .rfp-nav-icon {
  opacity: 1;
  color: #5e72e4;
}
.reports-panel-dark .rfp-nav-action .rfp-nav-icon {
  color: #a78bfa;
}
.rfp-nav-builder {
  color: #5e72e4 !important;
  font-weight: 600;
}
.reports-panel-dark .rfp-nav-builder {
  color: #a78bfa !important;
}
.rfp-nav-builder .rfp-nav-icon {
  opacity: 1;
  color: #5e72e4;
}
.reports-panel-dark .rfp-nav-builder .rfp-nav-icon {
  color: #a78bfa;
}

/* ── Right content column ── */
.rfp-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
}

/* Search */
.rfp-search-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid rgba(0,0,0,.07);
  flex-shrink: 0;
}
.reports-panel-dark .rfp-search-row {
  border-bottom-color: rgba(255,255,255,.07);
}
.rfp-search-icon {
  color: #aaa;
  font-size: 13px;
  flex-shrink: 0;
}
.rfp-search {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 13.5px;
  color: inherit;
  min-width: 0;
}
.rfp-search::placeholder { color: #aaa; }
.reports-panel-dark .rfp-search { color: #d0d0e0; }

/* Items scroll area */
.rfp-items-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 6px 8px;
}

/* Individual report item */
.rfp-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 6px;
  text-decoration: none !important;
  color: inherit;
  transition: background .12s;
  cursor: pointer;
}
.rfp-item:hover {
  background: rgba(94,114,228,.08);
}
.reports-panel-dark .rfp-item:hover {
  background: rgba(130,94,228,.12);
}
.rfp-item-all {
  margin-top: 4px;
  border-top: 1px solid rgba(0,0,0,.07);
  padding-top: 10px;
}
.reports-panel-dark .rfp-item-all {
  border-top-color: rgba(255,255,255,.07);
}
.rfp-item-icon-wrap {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: rgba(94,114,228,.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #5e72e4;
  font-size: 12px;
  margin-top: 1px;
}
.reports-panel-dark .rfp-item-icon-wrap {
  background: rgba(130,94,228,.18);
  color: #a78bfa;
}
.rfp-item-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.rfp-item-name-row {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
}
.rfp-item-name {
  font-size: 14px;
  font-weight: 500;
  color: #303550;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reports-panel-dark .rfp-item-name { color: #e0e0f0; }
.rfp-premium-badge {
  flex-shrink: 0;
  font-size: 10px;
  color: #B85A0B;
}
.reports-panel-dark .rfp-premium-badge { color: #fbbf4b; }
.rfp-item-desc {
  font-size: 12px;
  color: #8392ab;
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reports-panel-dark .rfp-item-desc { color: #6a6a8a; }

/* Empty / loading state */
.rfp-state-msg {
  text-align: center;
  padding: 32px 12px;
  color: #aaa;
  font-size: 13px;
}

/* Mobile */
@media (max-width: 600px) {
  .reports-float-panel {
    width: calc(100vw - 16px);
  }
  .rfp-layout {
    height: auto;
    flex-direction: column;
  }
  .rfp-nav {
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    border-right: none;
    border-bottom: 1px solid rgba(0,0,0,.07);
    padding: 6px;
    gap: 2px;
  }
  .rfp-nav-item {
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 12px;
  }
  .rfp-nav-item.active {
    border-right: none;
    background: rgba(94,114,228,.12);
  }
  .rfp-nav-spacer { display: none; }
  .rfp-builder-btn { margin: 4px 0 0; }
  .rfp-items-scroll { max-height: 260px; }
}

/* ─── Dashboards Float Panel ───────────────────────────────────── */
.dashboards-float-panel {
  position: fixed;
  z-index: 3000;
  background: #fff;
  border: 1px solid rgba(0,0,0,.08);
  border-radius: 10px;
  box-shadow: 0 0 0 1px rgba(0,0,0,.05), 0 8px 32px rgba(0,0,0,.16);
  width: 320px;
  max-width: calc(100vw - 24px);
  font-size: 14px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.dashboards-panel-dark {
  background: #1e1e2e;
  border-color: rgba(255,255,255,.1);
  color: #d0d0e0;
}

/* Search row */
.dfp-search-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid rgba(0,0,0,.07);
  flex-shrink: 0;
}
.dashboards-panel-dark .dfp-search-row {
  border-bottom-color: rgba(255,255,255,.07);
}
.dfp-search-icon {
  color: #aaa;
  font-size: 13px;
  flex-shrink: 0;
}
.dfp-search {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 13.5px;
  color: inherit;
  min-width: 0;
}
.dfp-search::placeholder { color: #aaa; }
.dashboards-panel-dark .dfp-search { color: #d0d0e0; }

/* Items scroll area */
.dfp-items-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 6px 8px;
  max-height: min(400px, calc(100vh - 160px));
}

/* Individual dashboard item */
.dfp-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 6px;
  text-decoration: none !important;
  color: inherit;
  transition: background .12s;
  cursor: pointer;
}
.dfp-item:hover {
  background: rgba(94,114,228,.08);
}
.dashboards-panel-dark .dfp-item:hover {
  background: rgba(130,94,228,.12);
}
.dfp-item-icon-wrap {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: rgba(94,114,228,.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #5e72e4;
  font-size: 12px;
  margin-top: 1px;
}
.dashboards-panel-dark .dfp-item-icon-wrap {
  background: rgba(130,94,228,.18);
  color: #a78bfa;
}
.dfp-item-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.dfp-item-name {
  font-size: 14px;
  font-weight: 500;
  color: #303550;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dashboards-panel-dark .dfp-item-name { color: #e0e0f0; }
.dfp-item-desc {
  font-size: 12px;
  color: #8392ab;
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dashboards-panel-dark .dfp-item-desc { color: #6a6a8a; }

/* Empty / loading state */
.dfp-state-msg {
  text-align: center;
  padding: 24px 12px;
  color: #aaa;
  font-size: 13px;
}

/* Footer */
.dfp-footer {
  display: flex;
  flex-direction: column;
  gap: 2px;
  border-top: 1px solid rgba(0,0,0,.07);
  padding: 6px 8px;
  flex-shrink: 0;
}
.dashboards-panel-dark .dfp-footer {
  border-top-color: rgba(255,255,255,.07);
}
.dfp-footer-link {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #5e72e4;
  text-decoration: none !important;
  transition: background .12s;
}
.dfp-footer-link:hover {
  background: rgba(94,114,228,.08);
}
.dashboards-panel-dark .dfp-footer-link {
  color: #a78bfa;
}
.dashboards-panel-dark .dfp-footer-link:hover {
  background: rgba(130,94,228,.12);
}
.dfp-footer-create {
  color: var(--c-primary-600, #5e72e4);
}
</style>
